import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required, minValue, numeric } from 'vuelidate/lib/validators';
import datePicker from '../../../components/forms/component.date-picker.vue';
import ageSwitch from '../../../components/forms/component.age-birthdate-input-switch.vue';
import { MainVueOpts } from '../../../main-vue';
import {
    isAfterField,
    monthDate,
    dateNotInFuture,
    createDateByLangStr,
    convertDateByLang,
    createDateByLangApplications,
    numbersWithDashSlash,
    noAlphabets
} from '../../../helper-functions/helper-functions';
import {
    createUpdateApplicationService,
    changeInSessionStorage,
    goToFirstError,
    hideValidationsWhileTyping
} from '../../../helper-functions/services';
import Step1Mixin from '../mixins/Step1Mixin';
import { imgPlanIds } from './shared';

Vue.use(Vuelidate);

export default {
    mixins:[MainVueOpts, Step1Mixin],
    components:{
        'date-picker': datePicker,
        'age-switch': ageSwitch
    },
    props:['form-data'],
    data: function() {
        return {
            travelerLimit: 10,
            formSending: false,
            showMobileError:false,
            showStartDateError: false,
            startDateTodayError: false,
            showTravelerValidation: false,
            canAddMore: true,
            totalNumberOfTravelers : 0,
            showChildrenRequiredError: false,
            submitted: false,
            residenceState: '',
            initialTripDeposit: window.ibJS.application ? window.ibJS.application.initialTripDepositDate : '',
            showSecondaryValidationForTripCost: false,
            showPrimaryValidationForTripCost: false,
            showSecondaryValidationForAge: false,
            showPrimaryValidation: false,
            showSpouseValidation: false,
            triggerAllTravelerValidation: false,
            UserLoggedInMyAcoount: ibJS.UserLoggedInMyAcoount,

        }
    },
    validations: function(){
        var validations = {
            form: {
                startDate: {
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets,
                    required
                },
                endDate: {
                    required,
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets,
                    isAfterStartDate: isAfterField('startDate', false)
                },
                travelerInfos:{
                    $each:{
                        // Only with vuelidate no custom methods
                        age:{
                            required
                        },
                        tripCost: {
                            required,
                            numeric,
                            minValue: minValue(1),
                            minTripCostChoiceCruise: (value) => {
                                if (this.form.planId !== imgPlanIds.Choice_Cruise) return true;
                                if (!value || value === '') return true;
                                return Number(value) >= 500;
                            }
                        }
                    }
                }
            },
            residenceState: {
                required
            },
            initialTripDeposit: {
                required,
                numbersWithDashSlash,
                noAlphabets,
                dateNotInFuture,
                monthDate
            }
        };

        if(this.form.endDate==''){
            this.showEndDateError=true;
        }else{
            this.showEndDateError=false;
        }

        if(this.form.startDate!='' && this.form.endDate!=''){
            var startDate = createDateByLangStr(this.form.startDate,'en');
            var endDate = createDateByLangStr(this.form.endDate,'en');
        }

        if(this.clickedDelete) {
            delete validations.form.travelerInfos.$each.age.requireChildren;
        }

        if(Array.isArray(this.form.travelerInfos) && this.form.travelerInfos.length) {
            if(this.form.travelerInfos[0].age == null || this.form.travelerInfos[0].age == "") {
                this.showPrimaryValidation = true;
            } else {
                this.showPrimaryValidation = false;
            }

            if(this.form.travelerInfos[0].tripCost == null || this.form.travelerInfos[0].tripCost == "") {
                this.showPrimaryValidationForTripCost = true;
            } else {
                this.showPrimaryValidationForTripCost = false;
            }
        }

         /* No need to display traveler error msg only when the number of travelerslarger than 3. will delete once we do not change back anymore */
        // let isTouched = false;
        // if(this.form.travelerInfos.length >= 3) {
        //     for(var i = 1 ; i < this.form.travelerInfos.length; i++) {
        //         if(this.form.travelerInfos.length > 3) {
        //             isTouched = true;
        //             break;
        //         } else if((this.form.travelerInfos[i].age != null && this.form.travelerInfos[i].age.toString().trim() != "")
        //             || (this.form.travelerInfos[i].tripCost != null && this.form.travelerInfos[i].tripCost.toString().trim() != "")) {
        //             if(i==1 && (this.form.travelerInfos[i].age != null && this.form.travelerInfos[i].age.toString().trim() != "")
        //             && (this.form.travelerInfos[i].tripCost != null && this.form.travelerInfos[i].tripCost.toString().trim() != "")) {

        //             } else {
        //                 isTouched = true;
        //                 break;
        //             }
        //         }
        //     }
        // }
        // if(isTouched) {
        //     validations.form.travelerInfos.$each.age.required = required;
        //     validations.form.travelerInfos.$each.tripCost.required = required;
        // } else {
        //     delete validations.form.travelerInfos.$each.age.required;
        //     delete validations.form.travelerInfos.$each.tripCost.required;
        // }

        return validations;
    },
    created: function(){
        var self = this;

        if(self.application != null){           
            if(this.application.travelerInfos !== null && this.application.travelerInfos.length) {
                self.form.travelerInfos =[];

                // if BE sends tripCost as 0, set to emptry string
                this.application.travelerInfos.forEach( traveler => {
                    if(traveler.tripCost === 0) {
                        traveler.tripCost = '';
                    }
                });

                for(var i=0;i<self.application.travelerInfos.length;i++){
                    if(!self.application.travelerInfos[i].birthYear && self.application.travelerInfos[i].birthDate) {
                        let birthYear = self.application.travelerInfos[i].birthDate.split('/')[2];
                        self.application.travelerInfos[i].birthYear = birthYear;
                    }
                    
                    var newTraveler = {
                        age: self.application.travelerInfos[i].birthYear ? self.application.travelerInfos[i].birthYear : '',
                        tripCost: self.application.travelerInfos[i].tripCost,
                        quotePrice:null,
                        travelerType:self.application.travelerInfos[i].travelerType
                    };

                    self.form.travelerInfos.push(newTraveler);
                }
            } else {
                if(self.form.travelerInfos && self.form.travelerInfos.length > 1) {
                    self.form.travelerInfos = self.form.travelerInfos.slice(0,1);
                }
            }

            self.residenceState = ibJS.application ? ibJS.application.homeCountryAddress ? ibJS.application.homeCountryAddress.state : '' : ''

            /* No need to add empty optional traveler anymore,  will delete once we do not change back anymore */
            // if(self.form.travelerInfos && Array.isArray(self.form.travelerInfos) && self.form.travelerInfos.length==1){
            //     var traveler1 = {
            //         age: null,
            //         tripCost: null,
            //         quotePrice:null,
            //         travelerType:''
            //     };
            //     var traveler2 = {
            //         age: null,
            //         tripCost: null,
            //         quotePrice:null,
            //         travelerType:''
            //     };
            //     self.form.travelerInfos.push(traveler1);
            //     self.form.travelerInfos.push(traveler2);
            // }else if(self.form.travelerInfos && Array.isArray(self.form.travelerInfos) && self.form.travelerInfos.length==2){
            //     var traveler = {
            //         age: null,
            //         tripCost: null,
            //         quotePrice:null,
            //         travelerType:''
            //     };
            //     self.form.travelerInfos.push(traveler);
            // }

            self.travelersOpened = true;

            // When coming from the quote results and children are present. Asks to input child age

            for(var i=0;i<self.form.travelerInfos.length;i++) {
                if(ibJS.application.travelerInfos[i] && ibJS.application.travelerInfos[i].birthYear) self.form.travelerInfos[i].age = ibJS.application.travelerInfos[i].birthYear;
                if(self.form.travelerInfos[i].age==-1){
                    self.form.travelerInfos[i].age=null;
                    self.showChildErrorText=true;
                    self.showTravelers=true;
                }
            }
        } else {
            // For trip plan, only keep one blank traveler
            if(self.form.travelerInfos && self.form.travelerInfos.length > 1) {
                self.form.travelerInfos = self.form.travelerInfos.slice(0,1);
            }
        } 

        $(document).ready(function () {
            $('.o-Form').on('click', function () {
                self.showTravelers = false;
            });

            $('.js-Stop-propagation').on('click', function (e) {
                e.stopPropagation();
            });
        });
    },
    watch:{
        'form.startDate' : function(){
            this.showMobileError = false;
        },
        'form.endDate' : function(){
            this.showMobileError = false;
        }
    },
    computed: {
        /* No need to display traveler error msg only when the number of travelerslarger than 3. will delete once we do not change back anymore */
        // travelerTripCostShowValidation: function () {
        //     let isVisible = false;

        //     if(this.form.travelerInfos.length <= 3) {
        //         if(!this.form.travelerInfos[2].tripCost && !this.form.travelerInfos[2].age) {
        //             isVisible = false;
        //         } else {
        //             isVisible = true;
        //         }
        //     } else {
        //         isVisible = true;
        //     }

        //     return isVisible;
        // }
        disableContinue() {
            return this.$v.form.$error && this.$v.form.$invalid || (this.$v.form.$dirty && (this.showPrimaryValidation || this.showPrimaryValidationForTripCost)) || this.$v.initialTripDeposit.$error;
        }
    },
    mounted: function(){
        convertDateByLang(this.form,window.globalLanguage.lang);
        hideValidationsWhileTyping(['initialTripDeposit']);
    },
    methods: {
        createQuote: function (e) {
            e.preventDefault();
            var error =false;
            this.showPrimaryValidation=false;
            this.showChildValidation=false;
            this.showSpouseValidation=false;

            this.$v.$touch();

            if(this.form.travelerInfos[0].age===null || this.form.travelerInfos[0].age===''){
                error=true;
                this.showPrimaryValidation=true;
            }


            if(this.form.travelerInfos.length > 0 &&
                (this.form.travelerInfos[0].tripCost == null || this.form.travelerInfos[0].tripCost == '')) {
                error = true;
                this.showPrimaryValidationForTripCost = true;
            }


            if (!this.$v.$invalid &&  error === false && !this.showEndDateError && (this.homeCountryOption === '' || this.homeCountryOption === 'No')) {
                for(var k=1;k<this.form.travelerInfos.length;k++) {
                    if (!this.showPrimaryValidation && !this.showSpouseValidation && !this.showChildValidation
                        && (this.form.travelerInfos[k].age === null || this.form.travelerInfos[k].age === '')) {
                        this.form.travelerInfos.splice(k, 1);
                        k -= 1;
                    }
                }
            }

            for(var i=1;i<this.form.travelerInfos.length;i++){

                        // For validation while skiping age fields.
                if(!this.showPrimaryValidation && !this.showSpouseValidation && !this.showChildValidation
                    && (this.form.travelerInfos[i].age===null || this.form.travelerInfos[i].age==='')){
                    for(let j = i+1; j < this.form.travelerInfos.length; j++){
                        if(this.form.travelerInfos[j] && (this.form.travelerInfos[j].age !==null && this.form.travelerInfos[j].age !=='')){
                            $('#traveler_'+i+'_missingInsured_error').css('display','');
                            error = true;
                            Vue.nextTick(() => goToFirstError() )
                            break;
                        }
                    }
                }
                else{
                    $('#traveler_'+i+'_missingInsured_error').css('display','none');
                }


                // adding logic for trip cost if the age is filled and the corresponding trip cost is not filled and vice versa

                if((this.form.travelerInfos[i].tripCost != null && this.form.travelerInfos[i].tripCost != '')&&(this.form.travelerInfos[i].age == null || this.form.travelerInfos[i].age == '')){
                    error = true;
                    this.showSecondaryValidationForAge = true;
                }
                else{
                    this.showSecondaryValidationForAge = false;
                }
            }

            var quoteResultsURL='/api/'+ibJS.productName+'/quote-results/?lang=en';
            if (!this.$v.$invalid && !error && !this.showEndDateError && this.form.travelerInfos.length < 11) {
                var _this = this;

                this.spliceTravelers();

                Vue.nextTick(() => {
                    let langBasedData = Object.assign({}, JSON.parse(JSON.stringify(this.form)));
                    changeInSessionStorage.call(this, "appFromQuoteResult", false);
                    createDateByLangApplications(langBasedData, window.globalLanguage.lang);
                    langBasedData.homeCountryAddress = {};

                    langBasedData.homeCountryAddress.state = this.residenceState;
                    langBasedData.initialTripDepositDate = this.initialTripDeposit;
                    langBasedData.travelerInfos = langBasedData.travelerInfos.filter((item)=>{
                        item.birthYear = parseInt(item.age);
                        item.tripCost = parseInt(item.tripCost);
                        delete item.age;
                        return item;
                    });
                    langBasedData.travelerInfos = JSON.parse(JSON.stringify(langBasedData.travelerInfos));
                    //delete langBasedData.travelerInfos;
                    const defaultTravelers = 1;
                    createUpdateApplicationService.call(this, quoteResultsURL, langBasedData, 'application', defaultTravelers === 1); // if default is one traveler pass the last parameter as true
                    this.submitted = true;
                });
                this.submitted = false;
            }else{
                this.showMobileError = true;
                Vue.nextTick(() => goToFirstError() );
            }
        },
        createDate: function(){
            if(this.form.startDate!='' && this.form.endDate!=''){
                var startDate = createDateByLangStr(this.form.startDate,'en');
                var endDate = createDateByLangStr(this.form.endDate,'en');
            }
        },
        addChild: function(){
            var numbOfChildrenList = this.form.childrenListArray.length;
            var newTraveler = {
                tripCost: null,
                age: null,
                travelerType:'child'
            };
            if(numbOfChildrenList < 8){
                this.form.childrenListArray.push(newTraveler);
            }
        },
        resetAgeValidation: function(index,type){
            if(!(/^\d+$/.test(this.form.travelerInfos[index].age))){
                this.form.travelerInfos[index].age=null;
            }
            if(index==0){
                this.showPrimaryValidation=false;
            }else if(index==1){
                this.showSpouseValidation=false;
                this.showChildErrorText=false;
                this.showSecondaryValidationForAge = false;
            }else if(index>1){
                this.showChildValidation=false;
                this.showChildErrorText=false;
                this.showSecondaryValidationForAge = false;
                $('#traveler_'+index+'_childAge_error').css('display','none');
            }

            // adding the trip cost check for resetting the errors after input

            if(!(/^\d+$/.test(this.form.travelerInfos[index].tripCost))){
                this.form.travelerInfos[index].tripCost=null;
            }

            if(index == 0){
                this.showPrimaryValidationForTripCost = false;
            }
            if(index > 0){
                this.showSecondaryValidationForTripCost = false;
            }
            this.showMobileError=false;
        },
        removeMobileError: function() {
            this.showMobileError = false;
        },
        addTraveler: function() {
            var newTraveler = {
                tripCost: null,
                age: null,
                travelerType:''
            };
            if(this.form.travelerInfos.length == 3) this.triggerAllTravelerValidation = true;
            this.form.travelerInfos.push(newTraveler);
        },
        spliceTraveler: function($index) {
            this.clickedDelete = true;
            this.showChildErrorText = false;
            this.showOtherErrorText = false;
            if(this.showMobileError) {
                this.showMobileError = false
            }
            this.form.travelerInfos.splice($index, 1);
            let isTouched = false;
            if(this.form.travelerInfos.length == 3) {
                for(var i = 1 ; i < this.form.travelerInfos.length; i++) {
                    if((this.form.travelerInfos[i].age != null && this.form.travelerInfos[i].age.toString().trim() != "")
                        || (this.form.travelerInfos[i].tripCost != null && this.form.travelerInfos[i].tripCost.toString().trim() != "")) {
                        isTouched = true;
                        break;
                    }
                }
                if(isTouched === false) {
                    this.triggerAllTravelerValidation = false;
                }
            }
        }
    }
};
